import React, { useEffect, useState } from 'react'
import TableComponent from '../../../components/DataTable/TableComponent'
import { loadingHide, loadingShow } from '../../../loadingUi/loading.controller';
import { getApi } from '../../../api/call.api';
import { urlApi } from '../../../api/url.api';
import { dateTimeConverter } from '../../../utils/dateTimeConverter';
import CreateOrgModal from '../../../components/Organization/CreateOrgModal';
import Pagination from '../../../components/Pagination/Pagination';
import { Badge } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { PROFILE } from '../../../statics/localStorage';
import UpdateOrgModal from './UpdateOrgModal';
import IconButton from '../../../components/Buttons/IconButton';
import { IconPencil } from '@tabler/icons-react';

const OrganizationTab = () => {

    const [tableData, setTableData] = useState({
        data: [],
        totalCount: 0
    });

    const [activePage, setActivePage] = useState(1);
    const [perPage, setPerPage] = useState(10);

    const navigate = useNavigate();
    const profileData = PROFILE();

    async function getTableData() {
        loadingShow();

        let url = `${urlApi.getOrganizationListDetailedData}?page=${activePage}&limit=${perPage}&`;
        let resp = await getApi(url);
        loadingHide();
        if (resp.responseCode === 200) {
            setTableData({
                data: resp.data.items,
                totalCount: resp.data.count
            });
        } else {
            setTableData({
                data: [],
                totalCount: 0
            });
        }
    }

    function handlePageChange(page) {
        setActivePage(page);
    }

    function handlePerRowsChange(newPerPage, page) {
        setActivePage(page);
        setPerPage(newPerPage)
    }

    useEffect(() => {
        getTableData();
    }, [activePage]);

    const selectOrganization = async (organization) => {
        loadingShow();
        let resp = await getApi(urlApi.switchOrganization + organization?.organizationId);
        loadingHide();
        if (resp.responseCode === 200) {
            navigate('/', { replace: true })
        } else {
            toast.error(resp.message);
        }
    }


    const columns = [
        {
            name: "Logo", center: 'true', grow: 0.5, selector: (row) => row?.channel_name, cell: (row) => (
                <img src={row?.organizationIcon} alt='' className='h-14 aspect-square rounded-full object-cover' />
            )
        }, {
            name: "Name", center: "true", selector: (row) => row?.category, cell: (row) => (
                <div>
                    <p className="mb-1 font-medium">{row?.name}</p>
                    <Badge bg={row?.organizationStatus == 1 ? 'success' : 'danger'}>{row?.organizationStatus == 1 ? 'Active' : 'Inactive'}</Badge>
                </div>
            )
        }, {
            name: "My Role", selector: (row) => row?.role, grow: 0.5, cell: (row) => (
                <p className="mb-0.5 font-semibold text-sm text-primary py-3">{row?.role == 1 ? "Admin" : "Member"}</p>
            )
        }, {
            name: "Created", center: "true", selector: (row) => row?.category, cell: (row) => (
                <div>
                    <div className='flex items-center gap-2 mb-2 justify-center'>
                        {row?.organizationOwnerProfilePic && <img src={row?.organizationOwnerProfilePic} alt='' className='h-8 aspect-square rounded-full object-cover' />}
                        <p className="mb-0">{row?.organizationOwnerName}</p>
                    </div>
                    <p className="mb-0">{dateTimeConverter(row?.createdAt)}</p>
                </div>
            )
        }, {
            name: "Action", center: "true", selector: (row) => row?.category, cell: (row) => (
                profileData?.defaultOrganizationId == row?.organizationId ? 'Selected Org.' : <button className='primary-btn' onClick={() => selectOrganization(row)}>Select Org.</button>
            )
        }, {
            name: "Update", center: "true", selector: (row) => row?.category, cell: (row) => (
                <UpdateOrgModal buttonComponent={<IconButton icon={<IconPencil size={18} />} text={"Update"} />} callback={() => getTableData()} orgData={row} />
            )
        }
    ];

    return (
        <div>
            <div className="flex items-center justify-between mb-3">
                <p className='text-[16px] font-semibold mb-0'>My Organizations</p>
                <CreateOrgModal callback={() => getTableData()} buttonComponent={<button className='primary-btn'>Create Organization</button>} />
            </div>
            <TableComponent
                isHeader={true}
                columns={columns}
                data={tableData.data}
                totalRows={tableData.totalCount}
                isPagination={false}
                paginationPerPage={perPage}
                handlePageChange={(e) => handlePageChange(e)}
                handlePerRowsChange={(newPerPage, page) => handlePerRowsChange(newPerPage, page)} />

            <Pagination itemsPerPage={perPage} totalCount={tableData.totalCount} pageChangeFunction={(pageNum) => handlePageChange(pageNum)} currentPage={activePage} />
        </div>
    )
}

export default OrganizationTab